import { ObjectType, Field, InputType, Int, ID, registerEnumType } from 'type-graphql'

import { PlayGroup } from './play-group.js'

@InputType({ description: 'Input for creating a new play group.' })
export class NewPlayGroup {
  @Field({ description: 'The name of the new play group.' })
  name: string

  @Field({ nullable: true, description: 'A detailed description for the new play group.' })
  description?: string
}

@InputType({ description: 'Input for updating (patching) an existing play group.' })
export class PlayGroupPatch {
  @Field({ nullable: true, description: 'The new name for the play group.' })
  name: string

  @Field({ nullable: true, description: 'The new description for the play group.' })
  description?: string
}

@ObjectType({ description: 'A paginated list of play groups.' })
export class PlayGroupList {
  @Field(type => [PlayGroup], { description: 'The list of play group items.' })
  items: PlayGroup[]

  @Field(type => Int, { description: 'The total number of play groups.' })
  total: number
}
